import * as types from "../../constants";

export const addToast = (payload: any) =>  {
  return {
    type: types.ADD_TOAST,
    payload: payload,
  };
}

export const removeToast = (index: number) =>  {
  return {
    type: types.REMOVE_TOAST,
    payload: index,
  };
}

export const removeToasts = () =>  {
  return {
    type: types.REMOVE_TOASTS,
  };
}